import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 修正：使用标准语言代码
const DEFAULT_LANG = 'en' // 默认语言为英文
const LOCALE_KEY = 'DemoLanguage'

const locales = {
  zh: require('./zh.json'),  // 中文
  ja: require('./jp.json'),  // 日语(标准代码)
  en: require('./en.json')   // 英文
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  silentTranslationWarn: true // 可选：禁止翻译警告
})

export const setup = async (lang) => {
  // 处理未定义语言的情况
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY)
    if (!locales[lang]) {
      // 从浏览器获取首选语言
      const browserLang = (navigator.language || navigator.userLanguage).split('-')[0]
      lang = locales[browserLang] ? browserLang : DEFAULT_LANG
    }
  }

  // 存储选择的语言
  window.localStorage.setItem(LOCALE_KEY, lang)

  // 修正：使用正确的模板字符串语法
  Object.keys(locales).forEach(item => {
    document.body.classList.remove(`lang-${item}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

// 初始化设置
setup()

export default i18n



// WEBPACK FOOTER //
// ./src/locales/index.js